/* Reiselieblinge – Sprachumschalter-Fix (Mobile) + Merken der Sprachwahl */
(function () {
  var KEY = 'rl_lang_choice';
  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function patch(lf) {
    if (lf.getAttribute('data-rl-lang')) return;
    lf.setAttribute('data-rl-lang', '1');
    var panel = lf.querySelector('.disclosure__list-wrapper');
    var btn = lf.querySelector('button');
    var form = lf.querySelector('form');
    var input = lf.querySelector('input[name="locale_code"], input[name="country_code"]');
    if (!panel || !form || !input) return;
    var isLang = input.name === 'locale_code';
    function choose(v) {
      if (isLang) store(v);
      input.value = v;
      form.submit();
    }
    /* Fokus bleibt beim Antippen auf dem Button -> Liste schließt sich nicht vor dem Klick */
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('touchend', function (e) {
      var a = e.target.closest('a[data-value]');
      if (!a) return;
      e.preventDefault();
      choose(a.getAttribute('data-value'));
    });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-value]');
      if (a && isLang) store(a.getAttribute('data-value'));
    }, true);
    /* Tippen außerhalb schließt die Liste */
    document.addEventListener('click', function (e) {
      if (!lf.contains(e.target) && btn) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    var lfs = document.querySelectorAll('localization-form');
    for (var i = 0; i < lfs.length; i++) patch(lfs[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
